import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { Destroyable, untilDestroy } from '@tokeet-frontend/tv3-platform'
import { catchError, finalize } from 'rxjs/operators'
import { of, Subscription } from 'rxjs'
import { AIService } from '@tokeet-frontend/ai'
import { select, Store } from '@ngrx/store'
import { selectActiveProductPlanView } from '@tv3/store/plan/plan.selectors'
import { ProductsForPlan } from '@tv3/store/plan/plan.model'
import { AppOverviewDialogService } from '@tokeet-frontend/billing'

@Component({
  selector: 'app-ai-summary',
  templateUrl: './ai-summary.component.html',
  styleUrls: ['./ai-summary.component.scss'],
})
export class AiSummaryComponent extends Destroyable implements OnInit, OnChanges {
  @Input() inquiry: Inquiry

  isLoading = false
  isSubscribed = false
  isPlanLoaded = false
  summary: string | null = null
  error: string | null = null
  private summarySubscription: Subscription | null = null

  constructor(
    private aiSummaryService: AIService,
    private store: Store<any>,
    private appOverviewDialog: AppOverviewDialogService
  ) {
    super()
  }

  ngOnInit() {
    this.store
      .pipe(select(selectActiveProductPlanView(ProductsForPlan.TokeetAI)), untilDestroy(this))
      .subscribe((sub) => {
        const isSubscribed = !!sub?.isValid
        this.isPlanLoaded = true

        if (this.isSubscribed === isSubscribed) return

        this.isSubscribed = isSubscribed
        if (this.isSubscribed) {
          this.loadSummary()
          return
        }

        this.resetSummary()
      })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['inquiry']?.currentValue?.id !== changes['inquiry']?.previousValue?.id) {
      this.loadSummary()
    }
  }

  loadSummary() {
    if (!this.inquiry?.id || !this.isSubscribed) {
      this.resetSummary()
      return
    }

    this.summarySubscription?.unsubscribe()

    this.isLoading = true
    this.summary = null
    this.error = null

    this.summarySubscription = this.aiSummaryService
      .generateGuestSummary(this.inquiry.id)
      .pipe(
        untilDestroy(this),
        finalize(() => (this.isLoading = false)),
        catchError(() => {
          this.error = 'Unable to generate summary. Please try again.'
          return of(null)
        })
      )
      .subscribe((res) => {
        if (res) {
          this.summary = res.guestSummary || null
        }
      })
  }

  subscribeToTokeetAI() {
    this.appOverviewDialog.open(ProductsForPlan.TokeetAI)
  }

  private resetSummary() {
    this.summarySubscription?.unsubscribe()
    this.summarySubscription = null
    this.isLoading = false
    this.summary = null
    this.error = null
  }
}
